import mixpanel from 'mixpanel-browser';

//const env_check = process.env.REACT_APP_ENVIRONMENT === 'DEV';
const env_check = true;
mixpanel.init(process.env.REACT_APP_MIXPANEL_PROJECT_TOEKN, { debug: env_check });

let mixpanelActions = {
  identify: (id) => {
    if (env_check) mixpanel.identify(id);
  },

  track: (name, props) => {
    if (env_check) mixpanel.track(name, props);
  },

  reset: () => {
    if (env_check) mixpanel.reset();
  },

  register: (props) => {
    if (env_check) mixpanel.register(props);
  },
};

export const Mixpanel = mixpanelActions;
